<template>
    <div class="container">
        <div class="helper">
            <div class="error" v-if="error">
                <div class="center-error">
                    <i :class="getIcon" class="icon"></i>
                    <p class="error-label">{{error}}</p>
                </div>
            </div>

            <div class="content">
                <div class="label-container">
                    <div class="label-helper">
                        <img :src="require(`@/assets/ula_logo.png`)">
                    </div>
                </div>
                <InputText :id="'username'"
                           :label="'Име'"
                           :placeholder="'Въведете име'"
                           @value-change="setCredentials"
                           class="input"
                           @keyup.enter.native="login()">
                </InputText>

                <InputText :id="'password'"
                           :label="'Парола'"
                           :placeholder="'Въведете парола'"
                           :hidden="true"
                           @value-change="setCredentials"
                           class="input"
                           @keyup.enter.native="login()">
                </InputText>

                <Button @click.native="login" :icon="'fa fa-lock-open'" :text="'Вход'" class="login-button"></Button>
            </div>
        </div>
    </div>
</template>

<script>
    import InputText from "@/shared/components/form/InputText";
    import Button from "@/shared/components/button/Button";
    import authorizationService from '@/services/authorization.service'
    import redirectService from "@/services/redirect.service";

    export default {
        name: "Login",
        components: {Button, InputText},
        created() {
            this.$store.commit('setUser', null);
        },
        data() {
            return {
                username: '',
                password: '',
                error: ''
            }
        },
        methods: {
            setCredentials(value) {
                this[value.id] = value.currentValue;
                this.error = '';
            },

            login() {
                authorizationService.login(this.username, this.password)
                    .then((response) => {
                        if (response.status === 400) {
                            this.error = response.data;
                        } else {
                            if (response.status === 200) {
                                this.$store.dispatch('fetchUser');
                                redirectService.redirectToWorkerList();
                            }
                        }
                    });
            }
        },
        computed: {
            getIcon() {
                return this.error ? 'fa fa-exclamation' : '';
            }
        }
    }
</script>

<style scoped>
    .container {
        display: table;
        height: 100%;
        position: absolute;
        overflow: hidden;
        width: 100%;
        margin-top: -50px;
        margin-left: -250px;
    }

    .helper {
        display: table-cell;
        vertical-align: middle;
    }

    .content {
        background-color: #ffffff;
        height: 500px;
        width: 500px;
        margin: 0 auto;
        border: 1px solid var(--light-grey);
        float: none;
        clear: both;
        padding: 0;
    }

    .label-container {
        height: fit-content;
        display: inline-block;
        float: left;
        width: inherit;
        font-size: 22px;
        padding: 5px;
        box-sizing: border-box;
        background-color: var(--lightest-grey);
        margin-bottom: 40px;
        border-bottom: 1px solid var(--light-grey);
    }

    .label-helper {
        width: fit-content;
        margin: auto;
    }

    .input {
        display: inline-block;
        float: left;
        width: 80%;
        height: 95px;
        position: relative;
        margin: 0 10% 40px 10%;
        border: none;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
    }

    .login-button {
        margin-top: 15px;
        height: 60px;
        width: 250px;
        font-size: 26px;
    }

    img {
        width: auto;
        height: 40px;
        float: left;
        margin: 10px 15px;
    }

    .error {
        color: var(--primary-red);
        height: 70px;
        display: inline-block;
        width: 490px;
        margin-top: -70px;
        padding: 5px;
        text-align: center;
        font-size: 25px;
        background-color: var(--very-light-red);
        border: 1px solid var(--light-red);
    }

    .center-error {
        width: fit-content;
        padding: 20px 20px 20px 40px;
        height: 100%;
        margin: auto;
        box-sizing: border-box;
    }

    .error-label {
        float: left;
        width: fit-content;
        height: 30px;
        box-sizing: border-box;
    }

    .icon {
        float: left;
        margin-left: -20px;
    }
</style>